<template>
    <div>
        <buttonlist
                @help="help"
                ref="SetBtn"
                @exps="exps"
        ></buttonlist>
        <div style="padding:8px">
            <tr>
                <td>
                    <el-link class="el-button--mini" type="primary" href="/excel/T_主计划.xlsx" download="T_主计划.xlsx" v-if="$processdata.getLang() != 2">{{$t('getapi[6111]')}}</el-link>
                    <el-link class="el-button--mini" type="primary" href="/excel/T_主计划.xlsx" download="Main_Plan.xlsx" v-if="$processdata.getLang() == 2">{{$t('getapi[6111]')}}</el-link>
                </td>
                <td>
                    <el-upload
                            class="upload-demo"
                            ref="upload"
                            :action="uploadurl"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :on-change="handleChange"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :file-list="fileList"
                            :limit="1"
                            style="margin-left: 8px"
                    >
                        <el-button slot="trigger" size="mini" type="primary" :disabled="!btn.Import">{{$t('getapi[372]')}}</el-button>
                    </el-upload>
                </td>
                <td>{{$t('getapi[4053]')}}</td>
                <td>
                    <el-date-picker v-model="date" value-format="yyyy-MM-dd" type="date" size="mini"
                                    style="width:100%"></el-date-picker>
                </td>
                <td>
                    <el-button type="primary" size="mini" @click="check"  style="margin-left: 8px">{{$t('getapi[439]')}}</el-button>
                </td>
                <td>
                    <el-button type="primary" size="mini" @click="count(0)" style="margin-left: 8px" :disabled="!btn.calc">{{$t('getapi[7276]')}}</el-button>
                </td>
                <td>
                    <el-button type="primary" size="mini" @click="expt" style="margin-left: 8px">{{$t('getapi[922]')}}</el-button>
                </td>
            </tr>
        </div>
        <el-tabs v-model="activeName" :tab-position="'top'" type="" style="margin-top: 0px" @tab-click="selectInfo">
            <el-tab-pane :label="$t('getapi[7094]')" name="0">
                <div  id="xpane-0">
                    <vxe-table :data="datajson" size="mini" :loading="loading" header-cell-class-name="headerclass" :height="tableHeight" stripe border resizable :auto-resize="true">
                        <vxe-table-column  show-footer-overflow v-for="item in returnArray"
                                           :key="item.Headen"
                                           :field="item.Headen"
                                           :title="item.Headcn"
                                           width="130px"
                                           sortable
                        ></vxe-table-column>
                    </vxe-table>
                </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('getapi[2530]') + $t('getapi[6368]')" name="1" id="xpane-1">
                <el-tabs v-model="activeNameSon" :tab-position="'top'" type="" style="margin-top: 0px">
                    <el-tab-pane :label="$t('getapi[1570]')" name="A">
                        <el-table
                                :data="dataSetA"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                :height="tableHeight1"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:0px"
                                ref="singleTable"
                        >
                            <el-table-column type="selection" v-if="false"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')" width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')" width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="price" :label="$t('getapi[1410]')" width="100" align="right">
                                <template slot-scope="scope">
                                    {{scope.row.price | thousandth}}
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="qty" :label="$t('getapi[1628]')" width="100" align="right">
                                <template slot-scope="scope">
                                    {{scope.row.qty | thousandth}}
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="total" :label="$t('getapi[2102]')" width="100" align="right">
                                <template slot-scope="scope">
                                    {{scope.row.total | thousandth}}
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[12842]')" name="B">
                        <el-table
                                :data="dataSetB"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                :height="tableHeight1"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:0px"
                                ref="singleTable"
                        >
                            <el-table-column type="selection" v-if="false"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="partcode" :label="$t('getapi[112]')" width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="partversion" :label="$t('getapi[149]')" width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="qty" :label="$t('getapi[1628]')" width="100" align="right">
                                <template slot-scope="scope">
                                    {{scope.row.qty | thousandth}}
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="total" :label="$t('getapi[2102]')" width="100" align="right">
                                <template slot-scope="scope">
                                    {{scope.row.total | thousandth}}
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[12849]')" name="C">
                        <el-table
                                :data="dataSetC"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                :height="tableHeight1"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:0px"
                                ref="singleTable"
                        >
                            <el-table-column type="selection" v-if="false"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="partcode" :label="$t('getapi[112]')" width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="partversion" :label="$t('getapi[149]')" width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="price" :label="$t('getapi[1410]')" width="100" align="right">
                                <template slot-scope="scope">
                                    {{scope.row.price | thousandth}}
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="qty" :label="$t('getapi[1628]')" width="100" align="right">
                                <template slot-scope="scope">
                                    {{scope.row.qty | thousandth}}
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="total" :label="$t('getapi[2102]')" width="100" align="right">
                                <template slot-scope="scope">
                                    {{scope.row.total | thousandth}}
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                </el-tabs>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: '2_penangonhand',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight2
            },
            tableHeight1(){
                return this.$windowSize.tableHeight1
            }
        },
        data() {
            return {
                dataSet: [], // 计算数据
                dataSetA: [], // 计算数据
                dataSetB: [], // 计算数据
                dataSetC: [], // 计算数据
                datajson:[],// 原始数据
                returnHeadArray: [], // 物料主文件表头
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: 50, // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                date: "", // 截至日期
                scrollTop:0,
                returnURL:'',
                uploadurl:'',
                fileList: [],
                returnArray:[],
                btn:{
                    //导入
                    Import:true,
                    schproshort: false,
                    calc:false,
                },
                activeName:'0',
                activeNameSon:'A',
                returnURLA:'',
                returnURLB:'',
                returnURLC:'',
            };
        },
        watch:{
            dataSet: function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            let token = JSON.parse(that.userData).token;
            that.uploadurl = Common.Url + '/MRP/Tool/GetPenangOnHandUpFile?token=' + token + '&LangType='+that.$processdata.getLang();
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[12838]"),this.$t("getapi[12837]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                if (that.dataSet.length > 0) {
                    that.$refs.SetBtn.SetButtonEnable('export');
                } else {
                    that.$refs.SetBtn.SetButtonEnable('');
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            check(){
                let that = this;
                that.loading = true;
                if (that.datajson.length<= 0)
                {
                    this.$message.warning(that.$t('getapi[8759]'));//"请首先添加原始数据！"
                    return;
                }

                let data ={
                    to_day:that.date,
                    "MultyVer": 0,
                    "iTemplate": '',
                    "FilePath": that.returnURL,
                    LangType: that.$processdata.getLang()
                };
                let token = JSON.parse(that.userData).token;
                let posturl = '/MRP/Tool/GetPenangOnHandCheck';
                that.$http.urlpost(posturl, data, function(res) {
                    if (res.Success == 1) {
                        that.btn.calc = true
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                    else{
                        if(res.DataContent.dt){
                            that.datajson=res.DataContent.dt;
                            that.returnArray = res.DataContent.TbHeader;
                            that.returnURL = res.DataContent.URL;
                        }
                    }
                    that.loading = false;
                });
            },
            count(val) {
                let that = this
                let parm = {
                    to_day: that.date,
                    "iTemplate": '',
                    "FilePath": that.returnURL,
                    LangType: that.$processdata.getLang(),
                    iscontinue: val
                }
                that.loading = true;
                that.btn.calc = false
                that.$http.urlpost('/MRP/Tool/GetPenangOnHand', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSetA = res.DataContent.DataListA;
                        that.dataSetB = res.DataContent.DataListB;
                        that.dataSetC = res.DataContent.DataListC;
                        that.returnURLA = res.DataContent.URLA
                        that.returnURLB = res.DataContent.URLB
                        that.returnURLC = res.DataContent.URLC
                        that.total = res.Totals;
                        that.activeName = '1'
                        that.activeNameSon = 'A'
                        that.authority();
                        that.loading = false;
                    } else if(res.Success > 1){
                        that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                            confirmButtonText: that.$t('getapi[1146]'),
                            cancelButtonText: that.$t('getapi[2054]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.count(res.Success)
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: that.$t('getapi[6096]')
                                });
                            });
                    }
                    that.btn.calc = true
                });
            },
            expt(){
                let that = this;
                if(that.activeNameSon=='A'){
                    if(that.dataSetA.length>0){
                        let hrefurl = Common.Url+that.returnURLA;
                        window.open(hrefurl);
                    }else{
                        this.$message.warning(that.$t('getapi[8757]'));//"暂无数据可导出!"
                    }
                }else if(that.activeNameSon=='B'){
                    if(that.dataSetB.length>0){
                        let hrefurl = Common.Url + that.returnURLB;
                        window.open(hrefurl);
                    }else{
                        this.$message.warning(that.$t('getapi[8757]'));//"暂无数据可导出!"
                    }
                }else if(that.activeNameSon=='C'){
                    if(that.dataSetC.length>0){
                        let hrefurl = Common.Url + that.returnURLC;
                        window.open(hrefurl);
                    }else{
                        this.$message.warning(that.$t('getapi[8757]'));//"暂无数据可导出!"
                    }
                }
            },
            selectInfo(tab, event) {
                let that = this;
                that.$nextTick(function(){
                    setTimeout(() => {
                        that.$processdata.initAllForm()
                    }, 500);
                });
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log("handlePreview"+file);
            },
            handleChange(file, fileList) {
                let that = this;
                that.loading = true;
                console.log(file);
                if (file.response) {
                    let response = file.response.Success;
                    if (response == 0) {
                        that.$message.error(that.$processdata.explainCallbackMsg(file.response.Msg));
                    } else {
                        that.datajson = file.response.DataContent.dt;
                    }
                    that.loading = false;
                }
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    //that.datajson = res.DataContent;
                    that.returnArray = res.DataContent.TbHeader;
                    that.returnURL = res.DataContent.URL;
                    that.datajson = res.DataContent.dt;
                    that.btn.calc = false
                }
                that.fileList=[];
                that.loading = false;
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initAllForm()
                    }, 500);
                })
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
                that.loading = false;
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
